const PathFinder = require('./../geojson-path-finder/index'),
  geojson = require('./../json/minify.json');

const pathfinder = new PathFinder(geojson, {
  precision: 1e-5,
  compact: false,
});

const Directions = {
  findPath(coordinates1, coordinates2) {
    let start = {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: coordinates1,
      },
    };

    let finish = {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: coordinates2,
      },
    };

    const path = pathfinder.findPath(start, finish);

    return path;
  },

  findPathToPath(graves, start) {
    let powFunc = (x, y) => {
      return Math.pow(x, 2) + Math.pow(y, 2);
    };

    let myPos = powFunc(start[1], start[0]);

    let closest = graves.reduce(function (prev, curr) {
      return Math.abs(powFunc(curr.Latitude, curr.Longitude) - myPos) <
        Math.abs(powFunc(prev.Latitude, prev.Longitude) - myPos)
        ? curr
        : prev;
    });

    let path = this.findPath([start[1], start[0]], closest.geometry.closestLL);

    if (path) {
      let rpath = path.path.map((path) => {
        return path[0] < path[1] ? path.reverse() : path;
      });

      return rpath;
    }
  },
};

export default Directions;



// WEBPACK FOOTER //
// ./src/services/directions.js